<template>
    <div class="v-popup-content">
        <div :is="dynamicComponent"></div>
    </div>
</template>
<script lang="ts">
import axios, { CancelTokenSource } from 'axios';
import { VueConstructor } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { $http } from '../app.config';
import BaseComponent from './Base';

@Component
    export default class Popup extends BaseComponent {
        @Prop({ type: String, required: true }) protected readonly link: string;
        @Prop({ type: String, default: '#content' }) protected readonly selector: string;
        @Prop() protected readonly props: any;

        protected content: string = '';
        protected source: CancelTokenSource | null = null;
        protected dynamicComponent: VueConstructor | null = null;

        public updateContent(): void {
            if (!this.link) {
                return;
            }
            const CancelToken = axios.CancelToken;
            this.source = CancelToken.source();
            const props = this.props || {};
            $http.get(this.link, {
                cancelToken: this.source.token,
            }).then(({ data }) => {
                this.source = null;
                const page = document.createElement('html');
                page.innerHTML = data;
                const content = page.querySelector('#content');
                if (content) {
                    this.content = content.innerHTML;
                    // eslint-disable-next-line vue/multi-word-component-names
                    this.dynamicComponent = Vue.component('Dynamic', {
                        template: `<div>${content.innerHTML}</div>`,
                        components: this.$root.$options.components,
                        computed: {
                            isPopup: () => true,
                        },
                        data() {
                            return props;
                        },
                    });
                    this.$emit('loaded');
                } else {
                    this.$emit('error', page);
                }
            }, (reason) => {
                this.$emit('error', reason);
            });
        }

        public beforeDestroy(): void {
            if (this.source) {
                this.source.cancel('Popup closed');
            }
        }

        public created(): void {
            this.$watch('link', this.updateContent);
            this.updateContent();
        }
    }
</script>
